module.exports = __webpack_public_path__ + "static/img/8.2a0a457.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/8.png
// module id = wHCi
// module chunks = 0